__turbopack_context__.v({
  "background": "BrandTiles-module-scss-module__piD6QW__background",
  "buttonGroup": "BrandTiles-module-scss-module__piD6QW__buttonGroup",
  "header": "BrandTiles-module-scss-module__piD6QW__header",
  "heading": "BrandTiles-module-scss-module__piD6QW__heading",
  "inner": "BrandTiles-module-scss-module__piD6QW__inner",
  "navButton": "BrandTiles-module-scss-module__piD6QW__navButton",
  "root": "BrandTiles-module-scss-module__piD6QW__root",
  "slide": "BrandTiles-module-scss-module__piD6QW__slide",
  "status": "BrandTiles-module-scss-module__piD6QW__status",
  "swiper": "BrandTiles-module-scss-module__piD6QW__swiper",
  "track": "BrandTiles-module-scss-module__piD6QW__track",
});
